<template>
  <v-container grid-list-xl fluid>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-tabs v-model="tab">
      <v-tab key="orderType">{{
        $t('checklists.tabs.by_order_type_tab')
      }}</v-tab>
      <v-tab key="lists">{{
          $t('checklists.tabs.checklists_tab')
      }}</v-tab>
      <v-tab key="groups">{{
          $t('checklists.tabs.groups_tab')
      }}</v-tab>
      <v-tab key="items">{{
          $t('checklists.tabs.all_items_tab')
      }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="orderType">
        <!-- check lists by order type€ -->
        <v-row class="my-4">
          <v-col cols="12" sm="6" class="d-flex pr-8">
            <h2 class="headline mr-8">
              <span>{{$t('checklists.by_order_type_tab.basic_cleaning')}}</span>
            </h2>
            <v-btn
              class="ml-2"
              @click="onUpdateChecklistMap('base')"
              >{{ $t('actions.save') }}</v-btn
            >
          </v-col>
          <v-col cols="12" sm="6" class="d-flex pl-8">
            <h2 class="headline mr-8">
              <span>{{$t('checklists.by_order_type_tab.complex_cleaning')}}</span>
            </h2>
            <v-btn
              class="ml-2"
              @click="onUpdateChecklistMap('complex')"
              >{{ $t('actions.save') }}</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" class="pr-8">
            <v-row class="mb-8" dense>
              <v-col cols="6">
                {{$t('checklists.by_order_type_tab.default_checklist')}}
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="baseChecklists.default"
                  :items="checkLists"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-for="orderType in BASE_TYPES" :key="orderType" dense>
              <v-col cols="6">
                {{$t('enums.order_base_types.'+orderType)}}
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="baseChecklists[orderType]"
                  :items="[
                    {
                      name: $t('checklists.by_order_type_tab.default_checklist'),
                      id: null
                    },
                    ...checkLists
                  ]"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" class="pl-8">
            <v-row class="mb-8" dense>
              <v-col cols="6">
                {{ $t('checklists.by_order_type_tab.default_checklist') }}
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="complexChecklists.default"
                  :items="checkLists"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-for="orderType in COMPLEX_TYPES" :key="orderType" dense>
              <v-col cols="6">
                {{$t('enums.order_complex_types.'+orderType)}}
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="complexChecklists[orderType]"
                  :items="[
                    {
                      name: $t('checklists.by_order_type_tab.default_checklist'),
                      id: null
                    },
                    ...checkLists
                  ]"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item key="lists">
        <!-- check lists -->
        <v-row class="mt-8">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <div class="d-flex align-center mr-16">
              <h2 class="headline mr-8">
                <span>{{$t('checklists.checklist_tab.title')}}</span>
              </h2>
              <v-btn
                class="ml-2"
                @click="onSaveItems('list')"
                :disabled="!formCheckLists"
                >{{ $t('actions.save') }}
              </v-btn>
            </div>
            <div class="d-flex align-center">
              <v-text-field
                ref="new-item"
                v-model="newCheckList.name"
                :label="$t('checklists.checklist_tab.new_list')"
                autocomplete="off"
                :rules="[rules.required, rules.min(3)]"
                class="mr-4"
              />
              <v-select
                v-model="newCheckList.groupIds"
                :items="checkGroups"
                item-text="name"
                item-value="id"
                multiple
                :rules="[rules.requiredArray(1)]"
                chips
                deletable-chips
                outlined
                dense
              ></v-select>
              <v-btn
                class="ml-8"
                @click="onAddItem('list')"
                :disabled="
                  !newCheckList.name ||
                    newCheckList.name.length < 3 ||
                    !newCheckList.groupIds.length
                "
                >{{ $t('actions.add') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-form v-model="formCheckLists">
          <v-row>
            <v-col v-for="list in checkLists" :key="list.id" cols="12" md="6">
              <v-card class="pa-2" flat outlined>
                <v-text-field
                  :ref="`list-${list.id}`"
                  v-model="list.name"
                  autocomplete="off"
                  :rules="[rules.required, rules.min(3)]"
                  append-outer-icon="mdi-delete"
                  @click:append-outer="onItemDelete('list', list.id)"
                  dense
                />
                <v-select
                  v-model="list.groupIds"
                  :items="checkGroups"
                  item-text="name"
                  item-value="id"
                  multiple
                  :rules="[rules.requiredArray(1)]"
                  chips
                  deletable-chips
                  dense
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>

      <v-tab-item key="groups">
        <!-- groups -->
        <v-row class="mt-8">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <div class="d-flex align-center mr-16">
              <h2 class="headline mr-8">
                <span>{{$t('checklists.groups_tab.title')}}</span>
              </h2>
              <v-btn
                class="ml-2"
                @click="onSaveItems('group')"
                :disabled="!formCheckGroups"
                >{{ $t('actions.save') }}</v-btn
              >
            </div>
            <div class="d-flex align-center">
              <v-text-field
                ref="new-item"
                v-model="newGroup.name"
                :label="$t('checklists.groups_tab.new_group')"
                autocomplete="off"
                :rules="[rules.required, rules.min(3)]"
                class="mr-4"
              />
              <v-select
                v-model="newGroup.itemIds"
                :items="checkItems"
                item-text="name"
                item-value="id"
                multiple
                :rules="[rules.requiredArray(1)]"
                chips
                deletable-chips
                outlined
                dense
              ></v-select>
              <v-btn
                class="ml-8"
                @click="onAddItem('group')"
                :disabled="
                  !newGroup.name ||
                    newGroup.name.length < 3 ||
                    !newGroup.itemIds.length
                "
                >{{ $t('actions.add') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-form v-model="formCheckGroups">
          <v-row>
            <v-col
              v-for="group in checkGroups"
              :key="group.id"
              cols="12"
              md="6"
            >
              <v-card class="pa-2" flat outlined>
                <v-text-field
                  :ref="`group-${group.id}`"
                  v-model="group.name"
                  autocomplete="off"
                  :rules="[rules.required, rules.min(3)]"
                  append-outer-icon="mdi-delete"
                  @click:append-outer="onItemDelete('group', group.id)"
                  dense
                />
                <v-select
                  v-model="group.itemIds"
                  :items="checkItems"
                  item-text="name"
                  item-value="id"
                  multiple
                  :rules="[rules.requiredArray(1)]"
                  chips
                  deletable-chips
                  outlined
                  dense
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>

      <v-tab-item key="items">
        <!-- Items -->
        <v-row class="mt-8">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
              <h2 class="headline mr-8">
                <span>{{$t('checklists.all_items_tab.title') }}</span>
              </h2>
              <v-btn
                class="ml-2"
                @click="onSaveItems('item')"
                type
                :disabled="!formCheckItems"
                >{{ $t('actions.save') }}</v-btn
              >
            </div>
            <div class="d-flex align-center">
              <v-text-field
                ref="new-item"
                v-model="newItem"
                :label="$t('checklists.all_items_tab.new_item')"
                autocomplete="off"
                :rules="[rules.required, rules.min(10)]"
              />
              <v-btn
                class="ml-8"
                @click="onAddItem('item')"
                :disabled="!newItem"
                >{{ $t('actions.add') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-form v-model="formCheckItems">
          <v-row>
            <v-col
              v-for="item in checkItems"
              :key="item.id"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              xl="2"
            >
              <v-text-field
                :ref="`item-${item.id}`"
                v-model="item.name"
                autocomplete="off"
                :rules="[rules.required, rules.min(10)]"
                append-outer-icon="mdi-delete"
                @click:append-outer="onItemDelete('item', item.id)"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>
    </v-tabs-items>

    <accept-dialog
      :is-open-dialog="isShowDeleteDialog"
      @on-close="isShowDeleteDialog = false"
      @on-accept="onAcceptDeletion"
    >
      <div class="pt-6">
        {{$t('checklists.delete_text')}}?
      </div>
    </accept-dialog>
  </v-container>
</template>

<script>
// import _ from 'lodash';
// import debounce from 'debounce';
// import moment from 'moment';
/* utils */
// import { prepareValidationMessages } from '@/utils/index';
/* proxies */
import CleanerProxy from '@/proxies/Cleaner/CleanerProxy';
/* mixins */
import validationMixin from '@/mixins/validationMixin';
/* components */
// import ModalLoading from '@/components/loaders/ModalLoading.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
/* constants */
import { COMPLEX_TYPES } from '~constants/order_complex_types';
import { BASE_TYPES } from '~constants/order_base_types';
import i18n from '@/i18n';

export default {
  name: 'CleaningCheckLists',
  components: {
    AcceptDialog
  },
  mixins: [validationMixin],
  data() {
    return {
      BASE_TYPES,
      COMPLEX_TYPES,
      tab: 0,
      items: ['items', 'groups', 'lists'],
      isLoading: false,
      isShowDeleteDialog: false,
      removeditem: null,
      removedgroup: null,
      removedlist: null,
      removedEntity: null,
      removedEntityId: null,
      newItem: null,
      newGroup: {
        name: null,
        itemIds: []
      },
      newCheckList: {
        name: null,
        groupIds: []
      },
      checkItems: [],
      checkGroups: [],
      checkLists: [],
      baseChecklists: { default: null },
      complexChecklists: { default: null },
      formCheckItems: false,
      formCheckGroups: false,
      formCheckLists: false
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    checkItemsById() {
      return this.checkItems.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },
    checkGroupsById() {
      return this.checkGroups.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },
    checkListsById() {
      return this.checkLists.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    }
  },
  created() {
    this.clearBaseComplexChecklists();
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    clearBaseComplexChecklists() {
      this.BASE_TYPES.forEach(type => {
        this.baseChecklists[type] = null;
      });
      this.COMPLEX_TYPES.forEach(type => {
        this.complexChecklists[type] = null;
      });
    },
    fetchData() {
      this.isLoading = true;
      const client = new CleanerProxy();
      client
        // .setParameters({ region: this.searchParams.region })
        .checkLists()
        .then(response => {
          if (this.checkItems.length) {
            this.checkItems.splice(0);
          }
          if (this.checkGroups.length) {
            this.checkGroups.splice(0);
          }
          if (this.checkLists.length) {
            this.checkLists.splice(0);
          }
          this.clearBaseComplexChecklists();

          this.checkItems = response.data.items;
          this.checkGroups = response.data.groups;
          this.checkLists = response.data.checklists;
          response.data.baseChecklists.forEach(item => {
            this.baseChecklists[item.order_type] = item.checklist_id;
          });
          response.data.complexChecklists.forEach(item => {
            this.complexChecklists[item.order_type] = item.checklist_id;
          });
        })
        .catch(error => {
          console.error(error);
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Ошибка...',
            color: 'red darken-3'
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onAddItem(type) {
      this.isLoading = true;
      let data = null;
      if (type === 'item') {
        data = { name: this.newItem };
      }
      if (type === 'group') {
        data = { name: this.newGroup.name, items: this.newGroup.itemIds };
      }
      if (type === 'list') {
        data = {
          name: this.newCheckList.name,
          items: this.newCheckList.groupIds
        };
      }
      new CleanerProxy()
        .addItem(type, data)
        .then(result => {
          if (type === 'item') {
            this.checkItems.unshift({ id: result.data.id, name: this.newItem });
          } else if (type === 'group') {
            this.checkGroups.unshift({
              id: result.data.id,
              name: this.newGroup.name,
              itemIds: this.newGroup.itemIds
            });
          } else {
            this.checkLists.unshift({
              id: result.data.id,
              name: this.newCheckList.name,
              groupIds: this.newCheckList.groupIds
            });
          }
          this.newItem = null;
          this.newGroup = {
            name: null,
            itemIds: []
          };
          this.newCheckList = {
            name: null,
            groupIds: []
          };
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.data_added'),
            color: 'success darken-3'
          });
        })
        .catch(response => {
          console.error(response);
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.error')`...${response.data.message}`,
            color: 'red darken-3'
          });
        })
        .finally(() => {
          this.isLoading = false;
          this[type] = null;
        });
    },
    onSaveItems(type) {
      this.isLoading = true;
      let items;
      if (type === 'item') {
        items = this.checkItems.map(item => ({ id: item.id, name: item.name }));
      }
      if (type === 'group') {
        items = this.checkGroups.map(group => ({
          id: group.id,
          name: group.name,
          itemIds: group.itemIds
        }));
      }
      if (type === 'list') {
        items = this.checkLists.map(list => ({
          id: list.id,
          name: list.name,
          itemIds: list.groupIds
        }));
      }
      new CleanerProxy()
        .updateItems(type, { items })
        .then(() => {
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.data_updated'),
            color: 'success darken-3'
          });
        })
        .catch(response => {
          console.error(response);
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.error')`...${response.data.message}`,
            color: 'red darken-3'
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onUpdateChecklistMap(type) {
      this.isLoading = true;
      new CleanerProxy()
        .updateChecklistMap(type, type === 'base' ? this.baseChecklists : this.complexChecklists)
        .then(() => {
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.data_updated'),
            color: 'success darken-3'
          });
        })
        .catch(response => {
          console.error(response);
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.error')`...${response.data.message}`,
            color: 'red darken-3'
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onItemDelete(type, id) {
      this.removedEntity = type;
      this.removedEntityId = id;
      this.isShowDeleteDialog = true;
    },
    requestDeleteItem(type, id) {
      this.isLoading = true;
      new CleanerProxy()
        .deleteItem(type, id)
        .then(() => {
          this.fetchData();
        })
        .catch(response => {
          console.error(response);
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('checklists.notifications.error')`...${'error_type' in response.data ? this.lang(this.$store, `sap/listings.${response.data.error_type}`) : response.data.message}`,
            color: 'red darken-3'
          });
        })
        .finally(() => {
          this.isLoading = false;
          this[type] = null;
          this.removedEntity = null;
          this.removedEntityId = null;
        });
    },
    /* General */
    onAcceptDeletion() {
      if (['item', 'list', 'group'].includes(this.removedEntity) && this.removedEntityId !== null) {
        this.requestDeleteItem(this.removedEntity, this.removedEntityId);
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.available-table {
  td,
  th {
    text-align: center !important;
  }
}
.ok {
  color: green;
  font-weight: 400;
}
</style>
